import { applyFilters, doRequest } from "./helpers";
import isNil from "lodash/isNil";
import omitBy from "lodash/omitBy";

export default class EmailExemptionService {
  static async getEmailExemptions(filters = null) {
    let path = "/email_exemption/";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async getEmailExemptionsForFilters(filters = null) {
    let path = "/email_exemption/for_filters";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async getEmailExemption(id) {
    return doRequest("GET", `/email_exemption/${id}`);
  }

  static async createEmailExemption(data) {
    return doRequest("POST", "/email_exemption/", {
      data: omitBy(data, isNil),
    });
  }

  static async editEmailExemption(id, data) {
    return doRequest("PUT", `/email_exemption/${id}`, {
      data: omitBy(data, isNil),
    });
  }

  static async deleteEmailExemption(id) {
    return doRequest("DELETE", `/email_exemption/${id}`);
  }
}
